import { DatePipe, Location } from '@angular/common';
import { HttpEventType } from '@angular/common/http';
import { ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { BehaviorSubject, filter, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomAttachFilesComponent } from 'src/app/components/custom-attach-files/custom-attach-files.component';
import { CustomInitialConsecutiveComponent } from 'src/app/components/custom-initial-consecutive/custom-initial-consecutive.component';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { ClientStateEnums } from 'src/app/enum/client-state-enums';
import { ConstructionSiteStateEnums } from 'src/app/enum/construction-site-enums';
import { DevolutionStateEnums } from 'src/app/enum/devolution-state-enums';
import { WindowEnums } from 'src/app/enum/window-enums';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { BranchModel } from 'src/app/models/management/branch.model';
import { DevolutionPrintModel } from 'src/app/models/print/rental/devolution-print.model';
import { DevolutionDetailModel } from 'src/app/models/rental/devolution-detail.model';
import { DevolutionModel } from 'src/app/models/rental/devolution.model';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { InvoiceService } from 'src/app/services/invoicing/invoice.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { FreightService } from 'src/app/services/management/freight.service';
import { GeneralParameterService } from 'src/app/services/management/general-parameter.service';
import { DevolutionDetailService } from 'src/app/services/rental/devolution-detail.service';
import { DevolutionService } from 'src/app/services/rental/devolution.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { RepairComponent } from 'src/app/views/maintenance/repair/repair/repair.component';
import Swal from 'sweetalert2';
import { PrintPredevolutionModalComponent } from '../print-predevolution-modal/print-predevolution-modal.component';

@Component({
  selector: 'app-register-devolution',
  templateUrl: './register-devolution.component.html',
  styleUrls: ['./register-devolution.component.scss'],
  standalone: false
})
export class RegisterDevolutionComponent implements OnInit, OnDestroy {

  @ViewChild('attachFileDevolution') attachFileDevolutionComponent?: CustomModalComponent | null = null;
  @ViewChild('repairModal') repairModalComponent?: CustomModalComponent | null = null;
  @ViewChild('selectOptionPrint') selectOptionPrintModalComponent?: CustomModalComponent | null = null;
  @ViewChild('initialConsecutive') initialConsecutiveModalComponent?: CustomModalComponent | null = null;

  branchId: number = 0;
  clientId: number = 0;
  codeNameClient: string = '';
  companyId: number = 0;
  componentAttachFiles = CustomAttachFilesComponent;
  componentInitialConsecutiveModal = CustomInitialConsecutiveComponent;
  componentOptionPrintModal = PrintPredevolutionModalComponent;
  componentRepairModal = RepairComponent;
  dataPeriod: string | null = '';
  datePeriod: string | null = '';
  devolutionContract: DevolutionModel = new DevolutionModel();
  devolutionDetailRepair: DevolutionDetailModel = new DevolutionDetailModel();
  devolutionId: number = 0;
  devolutionPrintModel: DevolutionPrintModel = new DevolutionPrintModel();
  devolutionStateOpen: number = DevolutionStateEnums.abierto;
  disabledBtnSave: boolean = true;
  devolutionStateString: string = '';
  disabledDetail: boolean = true;
  disabledForm: boolean = false;
  filteredCostCenters: any[] = [];
  formDevolution: FormGroup = new FormGroup({});
  headerRepair: string = '';
  iconStateDevolution: string = 'pi pi-lock-open';
  inputsForAttachFiles$ = new BehaviorSubject<any>({
    listFiles: [],
    labelConsecutive: 0,
    disabled: false
  });
  inputsForModals$ = new BehaviorSubject<any>({
    devolutionId: 0,
    devolutionStateId: 0,
    permissionUpdatable: false
  });
  inputsForRepairModals$ = new BehaviorSubject<any>({
    devolutionDetailId: 0,
    disabledDetail: false
  });
  invoicingCutoffCode: string | number = '';
  isOpened: string | undefined = undefined;
  listBranch: any[] = [];
  listClient: CustomListDropdown[] = [];
  listCostCenter: any[] = [];
  listFiles: any[] = [];
  listTypeDocument: any[] = [{ label: 'Predevolución', value: true }, { label: 'Devolución', value: false }];
  listTransporter: any[] = [];
  listVehicle: any[] = [];
  listTypeRequirements: any[] = [];
  listDelayReasons: any[] = [];
  mainBranchByUser: BranchModel = new BranchModel();
  nameWindow: string = 'Captura Devoluciones';
  outputForAttachFiles$ = new Subject<any>();
  outputForInitialConsecutive$ = new Subject<any>();
  permissionPrint: boolean = false;
  permissionUpdatable: boolean = false;
  permissionsUser: Array<OptionWindowModel> = new Array<OptionWindowModel>();
  printOnlyQuantity: boolean = false;
  printOnlyStore: boolean = true;
  projectName = ProjectName.projectName;
  quantityDetails: number = 0;
  reloadPrint: boolean = false;
  stateClientId: number = ClientStateEnums.activo;
  stateCostCenterId: number = ConstructionSiteStateEnums.activa;
  statePeriod: string | null = '';
  swFreight: boolean = false;
  swIndicators: boolean = false;
  swIncludeStore: boolean = false;
  subscription: Subscription;
  transporterId: number = 0;
  titleStateDevolution: string = 'Cerrar';
  updateListDetail: boolean = false;
  url: string = 'devolution';
  userAuthenticated: UserModel = new UserModel();
  vehicleId: number = 0;


  constructor(private activatedRoute: ActivatedRoute,
    private branchService: BranchService,
    private cdr: ChangeDetectorRef,
    private confirmDialogService: ConfirmDialogService,
    private dateConverterService: DateConverterService,
    private datePipe: DatePipe,
    private devolutionService: DevolutionService,
    private devolutionDetailService: DevolutionDetailService,
    private formBuilder: FormBuilder,
    private formControlStateService: FormControlStateService,
    private freightService: FreightService,
    private generalParameterService: GeneralParameterService,
    private headerService: HeaderService,
    private invoiceService: InvoiceService,
    private location: Location,
    private optionWindowService: OptionWindowService,
    private router: Router,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService) {
    this.validateForm(this.devolutionContract);
    this.getFirstBranchByUserAuthenticated();
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getPermission();
    this.activatedRoute.params.subscribe(params => {
      this.devolutionId = Object.keys(params).length > 0 ? params?.id : null;
    });
    this.handleInitialState();

    this.subscription = this.outputForAttachFiles$.subscribe(async ({ type, payload }) => {
      switch (type) {
        case 'uploadFile':
          this.uploadFile(payload);
          break;
        case 'downloadFile':
          this.downloadFile(payload);
          break;
        case 'deleteFile':
          this.deleteFile(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });

    this.subscription = this.outputForInitialConsecutive$.subscribe(async ({ type, payload }) => {
      if (type === 'initialConsecutive') {
        this.formDevolution.patchValue({
          consecutive: payload.consecutive
        });
        await this.send();
      }
    });
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }

    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  async annulDevolution() {
    if (this.devolutionContract.devolutionId != 0 && this.devolutionContract.devolutionId != null) {
      if (this.permissionUpdatable) {
        if (!this.devolutionContract.swBlock) {
          if (this.devolutionContract.devolutionStateId === DevolutionStateEnums.anulado) {
            this.toastHandlerService.showToast(
              'warning',
              'La devolución se encuentra anulada.'
            );
          } else {
            if (this.quantityDetails !== 0) {
              this.toastHandlerService.showToast(
                'error',
                'No se puede anular un documento con detalle.'
              );
              return;
            }
            if (this.devolutionContract.isTransfer) {
              this.toastHandlerService.showToast(
                'warning',
                'Las devoluciones de tipo traslado solo pueden anularse desde la pantalla de traslados entre obras.'
              );
              return;
            }
            const accepted = await this.confirmDialogService.confirm(`¿Realmente desea anular la devolución actual?`);

            if (accepted) {
              try {
                this.devolutionContract = await firstValueFrom(this.devolutionService.annulDevolution(this.devolutionId));
                this.validateForm(this.devolutionContract);
                this.toastHandlerService.showToast(
                  'success',
                  'La devolución fue anulada exitosamente.'
                );
              } catch (error) {
                console.error("Error annuling service: ", error);
              }

            }
          }
        } else {
          this.toastHandlerService.showToast(
            'warning',
            'La devolución se encuentra bloqueada.'
          );
        }
      } else {
        this.toastHandlerService.showToast(
          'warning',
          'El usuario no tiene permisos para anular devoluciones. Comuníquese con el administrador del sistema.'
        );
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear una Devolución.'
      );
    }
  }

  async blockDevolution(checked: boolean) {
    if (this.devolutionContract.devolutionId != 0 && this.devolutionContract.devolutionId != null) {
      if (this.permissionUpdatable) {
        if (this.devolutionContract.devolutionStateId === DevolutionStateEnums.anulado) {
          this.formDevolution.controls["swBlock"].patchValue(!checked);
          this.toastHandlerService.showToast(
            'warning',
            'La devolución se encuentra anulada.'
          );
        } else {
          try {
            this.devolutionContract = await firstValueFrom(this.devolutionService.blockDevolution(this.devolutionContract.devolutionId));
            this.validateForm(this.devolutionContract);
          } catch (error) {
            console.error("Error to block the devolution:", error);
          }
        }
      } else {
        this.formDevolution.controls["swBlock"].patchValue(!checked);
        this.toastHandlerService.showToast(
          'warning',
          'El usuario no tiene permisos para bloquear devoluciones. Comuníquese con el administrador del sistema.'
        );
      }
    } else {
      this.formDevolution.controls["swBlock"].patchValue(!checked);
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear una Devolución.'
      );
    }
  }

  async changeConsecutive() {
    const branchId = this.formDevolution.get("branchId")?.value;
    let consecutive = this.formDevolution.get("consecutive")?.value;

    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una Sucursal.'
      );
      return;
    }
    if (consecutive === null || consecutive.toString().trim() === "") consecutive = 0;

    if (consecutive === 0) {
      this.createNewDevolution(branchId);
    } else {
      try {
        this.devolutionContract = await firstValueFrom(this.devolutionService.getDevolutionByKeysAsync(branchId, consecutive));
        this.validateForm(this.devolutionContract);
        this.devolutionId = this.devolutionContract.devolutionId;
        this.location.replaceState(`/devolution/register/${this.devolutionId}`);
        this.filteredCostCenters = this.listCostCenter;
      } catch (error) {
        this.formDevolution.controls["consecutive"].setValue(this.devolutionContract.consecutive);
        console.error("Error to get the devolution by keys:", error);
      }
    }
  }

  changeDateDevolution() {
    const dateDevolution = this.formDevolution.get("dateDevolution")?.value;
    this.formDevolution.controls["dateInvoice"].patchValue(dateDevolution);

    if (this.devolutionContract.isPredevolution && dateDevolution) {
      const datePredevolution = this.formDevolution.get("datePredevolution")?.value;
      if (dateDevolution < datePredevolution) {
        this.toastHandlerService.showToast(
          'warning',
          `La Fecha Devolución: ${moment(dateDevolution).format('YYYY-MM-DD')}, no puede ser menor a la Fec.Predevolución: ${moment(datePredevolution).format('YYYY-MM-DD')}.`
        );
      }
    }
  }

  changeDateInvoice() {
    this.disabledBtnSave = false;
  }

  changeDatePredevolution() {
    const datePredevolution = this.formDevolution.get("datePredevolution")?.value;
    this.formDevolution.controls["dateDevolution"].patchValue(datePredevolution);
    this.formDevolution.controls["dateInvoice"].patchValue(datePredevolution);
  }

  async changeDevolutionState() {
    if (this.devolutionContract.devolutionId !== 0 && this.devolutionContract.devolutionId !== null) {
      if (this.permissionUpdatable) {
        if (!this.devolutionContract.swBlock) {
          if (this.devolutionContract.invoicingCutoffId === 0 || this.devolutionContract.invoicingCutoffId === null) {
            if (!this.devolutionContract.isTransfer) {
              try {
                this.devolutionContract = await firstValueFrom(this.devolutionService.setDevolutionState(this.devolutionContract.devolutionId));
                this.validateForm(this.devolutionContract);
                this.toastHandlerService.showToast(
                  'success',
                  'El estado de la devolución fue cambiado exitosamente.'
                );
              } catch (error) {
                console.error("Error to change devolution state: ", error);
              }
            } else {
              this.toastHandlerService.showToast(
                'error',
                'Las devoluciones de tipo traslado solo se pueden modificar desde la pantalla de traslados entre obras.'
              );
            }
          } else {
            this.toastHandlerService.showToast(
              'error',
              'No se puede cambiar el estado de la devolución, ya se encuentra en un corte.'
            );
          }
        } else {
          this.toastHandlerService.showToast(
            'warning',
            'La devolución se encuentra bloqueada.'
          );
          return;
        }
      } else {
        this.toastHandlerService.showToast(
          'warning',
          'El usuario no tiene permisos para cambiar estado de devoluciones. Comuníquese con el administrador del sistema.'
        );
        return;
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear una Devolución.'
      );
      return;
    }
  }


  changeTransportValue() {
    const transportValue = this.formDevolution.get("transportValue")?.value;
    if (transportValue < 0) {
      this.toastHandlerService.showToast(
        'error',
        "El valor ingresado no es válido."
      );
    }
  }

  convertToDevolution() {
    if (this.devolutionContract.devolutionId != 0 && this.devolutionContract.devolutionId != null) {
      if (this.permissionUpdatable) {
        if (!this.devolutionContract.swBlock) {
          if (this.devolutionContract.devolutionStateId == DevolutionStateEnums.impreso) {
            Swal.fire({
              title: 'Atención',
              text: "¿Desea realizar la devolución con cantidades?",
              icon: 'question',
              showCancelButton: true,
              showDenyButton: true,
              confirmButtonColor: '#3085d6',
              denyButtonColor: '#d33',
              confirmButtonText: 'Si',
              denyButtonText: 'No',
              cancelButtonText: 'Cancelar'
            }).then(async (result) => {
              if (result.isConfirmed) {
                try {
                  this.devolutionContract.convertDevolutionWithQuatities = true;
                  this.devolutionContract = await firstValueFrom(this.devolutionDetailService.convertToDevolution(this.devolutionContract));
                  this.validateForm(this.devolutionContract);
                  this.toastHandlerService.showToast(
                    'success',
                    'La devolución fue generada exitosamente.'
                  );
                } catch (error) {
                  console.error("Error to convert predevolution: ", error);
                }
              } else if (result.isDenied) {
                try {
                  this.devolutionContract.convertDevolutionWithQuatities = false;
                  this.devolutionContract = await firstValueFrom(this.devolutionDetailService.convertToDevolution(this.devolutionContract));
                  this.validateForm(this.devolutionContract);
                  this.toastHandlerService.showToast(
                    'success',
                    'La devolución fue generada exitosamente.'
                  );
                } catch (error) {
                  console.error("Error to convert predevolution: ", error);
                }
              }
            });
          } else {
            this.toastHandlerService.showToast(
              'warning',
              'La predevolución debe estar impresa para convertirla a devolución.'
            );
          }
        } else {
          this.toastHandlerService.showToast(
            'warning',
            'El registro se encuentra bloqueado.'
          );
          return;
        }
      } else {
        this.toastHandlerService.showToast(
          'warning',
          'El usuario no tiene permisos para convertir predevoluciones. Comuníquese con el administrador del sistema.'
        );
        return;
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un registro.'
      );
      return;
    }

  }

  createNewDevolution(branchId: number) {
    this.devolutionContract = new DevolutionModel();
    this.devolutionContract.branchId = branchId;
    this.devolutionContract.consecutive = 0;
    this.devolutionContract.vehicleId = this.vehicleId;
    this.devolutionContract.transporterId = this.transporterId;
    this.devolutionId = 0;
    this.filterCostCenterByClientId(null);
    this.validateForm(this.devolutionContract);
    this.stateCostCenterId = ConstructionSiteStateEnums.activa;
    this.codeNameClient = "";
    this.stateClientId = ClientStateEnums.activo;
    this.disabledDetail = true;
    this.quantityDetails = 0;
    this.location.replaceState(`/devolution/register`);
  }

  async deleteDevolution() {
    if (this.devolutionContract.devolutionId != 0 && this.devolutionContract.devolutionId != null) {
      if (this.permissionUpdatable) {
        if (!this.devolutionContract.swBlock) {
          if (this.devolutionContract.devolutionStateId === DevolutionStateEnums.abierto) {
            const accepted = await this.confirmDialogService.confirm(`¿Realmente desea eliminar la devolución actual?`);

            if (accepted) {
              try {
                await firstValueFrom(this.devolutionService.deleteDevolution(this.devolutionId));
                const branchId = this.formDevolution.get("branchId")?.value;
                this.createNewDevolution(branchId);
                this.toastHandlerService.showToast(
                  'success',
                  'La devolución fue eliminada exitosamente.'
                );
              } catch (error) {
                console.error("Error deleting devolution: ", error);
              }
            }
          } else {
            this.toastHandlerService.showToast(
              'warning',
              'Para eliminar la devolución debe estar en estado Abierto.'
            );
          }
        } else {
          this.toastHandlerService.showToast(
            'warning',
            'La devolución se encuentra bloqueada.'
          );
          return;
        }
      } else {
        this.toastHandlerService.showToast(
          'warning',
          'El usuario no tiene permisos para eliminar devoluciones. Comuníquese con el administrador del sistema.'
        );
        return;
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear una Devolución.'
      );
      return;
    }
  }

  async deleteFile(file: any) {
    if (this.devolutionContract.devolutionId != 0) {
      const accepted = await this.confirmDialogService.confirm(`¿Realmente desea eliminar el adjunto seleccionado?`);

      if (accepted) {
        try {
          await firstValueFrom(this.devolutionService.deleteFilesToDevolution(this.devolutionContract.devolutionId, file));
          this.toastHandlerService.showToast('success', 'El adjunto fue eliminado exitosamente', '');
          this.getFilesToDevolution();
        } catch (error) {
          console.error('Error catch:', error);
        }
      }
    }
  }

  downloadFile(fileName: any) {
    if (this.devolutionContract.devolutionId != 0) {
      this.devolutionService.downloadFileToDevolution(this.devolutionContract.devolutionId, fileName).subscribe(data => {
        switch (data.type) {
          case HttpEventType.Response: {
            const downloadedFile = new Blob([data.body!], { type: data.body!.type });
            const a = document.createElement('a');
            a.setAttribute('style', 'display:none;');
            document.body.appendChild(a);
            a.download = fileName;
            a.href = URL.createObjectURL(downloadedFile);
            a.target = '_blank';
            a.click();
            document.body.removeChild(a);
            break;
          }
        }
      });
    }
  }

  filterCostCenterByClientId(clientId: number | null) {
    const rowsFiltered = this.listCostCenter.filter(cc => cc.clientId === clientId);
    if (clientId != null) {
      this.filteredCostCenters = rowsFiltered;
      const costCenterId = this.formDevolution.get("costCenterId")?.value;
      const costCenterClient = this.listCostCenter.find(x => x.clientId == clientId);
      if ((costCenterId && costCenterClient) && costCenterClient.value != costCenterId) {
        this.formDevolution.controls["costCenterId"].patchValue(0);
      }
    } else {
      this.filteredCostCenters = this.listCostCenter;
    }
  }

  finishLoading(finishPrint: boolean) {
    if (finishPrint) window.print();
  }

  async getAllLists(reload: boolean, ...listsToLoad: Array<'branches' | 'clients' | 'costCenters' | 'transporters' | 'vehicles'>) {
    try {
      const lists = {
        branches: async () => {
          this.listBranch = await firstValueFrom(
            this.branchService.getAllBranchesForSelectAsync()
          );
        },
        clients: async () => {
          this.listClient = await firstValueFrom(
            this.invoiceService.getAllClientsForSelectAsync()
          );
        },
        costCenters: async () => {
          this.listCostCenter = await firstValueFrom(
            this.devolutionService.getAllCostCentersForSelectAsync(this.branchId)
          );
          this.filteredCostCenters = this.listCostCenter;
        },
        transporters: async () => {
          this.listTransporter = await firstValueFrom(
            this.devolutionService.getAllTransportersForSelectAsync(this.branchId)
          );

          const defaultTransporter = this.listTransporter.find((x: any) => x.isDefault);
          if (defaultTransporter) {
            this.transporterId = defaultTransporter.value;
          }
        },
        vehicles: async () => {
          this.listVehicle = await firstValueFrom(
            this.devolutionService.getAllVehiclesForSelectAsync(this.branchId)
          );

          const defaultVehicle = this.listVehicle.find((x: any) => x.isDefault);
          if (defaultVehicle) {
            this.vehicleId = defaultVehicle.value;
          }
        },
        typeRequirement: async () => {
          this.listTypeRequirements = await firstValueFrom(
            this.devolutionService.getAllConceptsRequirementTypeForSelect()
          );
        },
        delayReason: async () => {
          this.listDelayReasons = await firstValueFrom(
            this.devolutionService.getAllConceptsDelayReasonForSelect()
          );
        },
      };

      if (reload) {
        await Promise.all([
          lists.costCenters(),
          lists.transporters(),
          lists.vehicles()
        ]);
      } else if (listsToLoad.length) {
        await Promise.all(listsToLoad.map(list => lists[list]()));
      } else {
        const promises = [
          lists.branches(),
          lists.clients(),
          lists.costCenters(),
          lists.transporters(),
          lists.vehicles(),
        ];

        if (this.swIndicators) {
          promises.push(
            lists.typeRequirement(),
            lists.delayReason()
          );
        }

        await Promise.all(promises);
      }

      return true;
    } catch (error) {
      console.error('Error getting lists.', error);
      return false;
    }
  }

  async getFirstBranchByUserAuthenticated() {
    this.getFirstBranchByUserAuthenticatedAsync();
  }

  async getBranch(branchId: number | null, reload: boolean) {
    if (branchId === null && branchId === 0) {
      this.formDevolution.controls["branchId"].patchValue(0);
    } else {
      this.branchId = branchId!;
      if (reload) {
        await this.getAllLists(true);
        this.createNewDevolution(branchId!);
      }
    }
  }

  async getButtonClick(buttonClick: any) {
    const branchId = this.formDevolution.get("branchId")?.value;
    let consecutive = this.formDevolution.get("consecutive")?.value;

    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una Sucursal.'
      );
      return;
    }
    if (consecutive == "" || consecutive == null) consecutive = 0;

    switch (buttonClick.target.id) {
      case 'first': {
        try {
          this.devolutionContract = await firstValueFrom(this.devolutionService.getFirstDevolutionByKeysAsync(branchId));
          this.validateForm(this.devolutionContract);
          this.devolutionId = this.devolutionContract.devolutionId;
          this.location.replaceState(`/devolution/register/${this.devolutionId}`);
        } catch (error) {
          console.error('Error to search first devolution by keys:', error);
        }
        break;
      }
      case 'previus': {
        try {
          this.devolutionContract = await firstValueFrom(this.devolutionService.getPreviusDevolutionByKeysAsync(branchId, consecutive));
          this.validateForm(this.devolutionContract);
          this.devolutionId = this.devolutionContract.devolutionId;
          this.location.replaceState(`/devolution/register/${this.devolutionId}`);
        } catch (error) {
          console.error('Error to search previus devolution by keys:', error);
        }
        break;
      }
      case 'next': {
        try {
          this.devolutionContract = await firstValueFrom(this.devolutionService.getNextDevolutionByKeysAsync(branchId, consecutive));
          this.validateForm(this.devolutionContract);
          this.devolutionId = this.devolutionContract.devolutionId;
          this.location.replaceState(`/devolution/register/${this.devolutionId}`);
        } catch (error) {
          console.error('Error to search next devolution by keys:', error);
        }
        break;
      }
      case 'last': {
        try {
          this.devolutionContract = await firstValueFrom(this.devolutionService.getLastDevolutionByKeysAsync(branchId));
          this.validateForm(this.devolutionContract);
          this.devolutionId = this.devolutionContract.devolutionId;
          this.location.replaceState(`/devolution/register/${this.devolutionId}`);
        } catch (error) {
          console.error('Error to search last devolution by keys:', error);
        }
        break;
      }
    }
  }

  async getClient(clientId: number | null, validate: boolean) {
    this.filterCostCenterByClientId(clientId);
    if (clientId != null && clientId != 0) {
      if (this.quantityDetails != 0) {
        this.toastHandlerService.showToast('error', 'No puede cambiar el cliente si la devolucion tiene detalle.', 'Error');
        this.getCostCenter(this.devolutionContract.costCenterId, true);
        this.formDevolution.controls["costCenterId"].patchValue(this.devolutionContract.costCenterId);
      } else {
        const client = await firstValueFrom(this.invoiceService.getClientByIdForRegisterInvoiceAsync(clientId));
        if (client.clientStateId == ClientStateEnums.inactivo && validate) {
          this.toastHandlerService.showToast('warning', 'El cliente seleccionado se encuentra inactivo.', 'Atención');
          this.stateClientId = client.clientStateId as number;
          this.formDevolution.controls["clientId"].patchValue(0);
          this.formDevolution.controls["costCenterId"].patchValue(0);
          this.filteredCostCenters = this.listCostCenter;
          return;
        }
        if (client) {
          this.clientId = clientId;
          this.stateClientId = client.clientStateId as number;

          const exist = this.listClient.some(c => c.value === this.clientId);
          if (!exist) {
            this.listClient.push({ label: client.label, value: this.clientId });
          }
        } else {
          if (this.quantityDetails != 0) {
            this.toastHandlerService.showToast('error', 'Error al buscar el elemento, por favor refresque la página.', 'Error');
          } else {
            this.clientId = 0;
            this.stateClientId = ClientStateEnums.activo;
            this.formDevolution.controls["clientId"].patchValue(0);
            this.formDevolution.controls["costCenterId"].patchValue(0);
          }
        }
      }
    } else {
      if (this.quantityDetails != 0) {
        this.toastHandlerService.showToast('error', 'No puede limpiar el cliente si la devolución tiene detalle.', 'Error');
        this.getCostCenter(this.devolutionContract.costCenterId, true);
      } else {
        this.clientId = 0;
        this.formDevolution.controls["clientId"].patchValue(0);
        this.formDevolution.controls["costCenterId"].patchValue(0);
        this.getCostCenter(null, false);
      }
    }
  }

  async getCostCenter(costCenterId: number | null, onInit: boolean) {
    if (costCenterId === null || costCenterId === 0) {
      if (this.quantityDetails !== 0) {
        this.stateClientId = ClientStateEnums.activo;
        setTimeout(() => this.formDevolution.controls["costCenterId"].patchValue(this.devolutionContract.costCenterId), 200);
        this.disabledDetail = true;
        let text;
        if (this.devolutionContract.isPredevolution)
          text = 'No puede limpiar el c.costos si la predevolución tiene detalle.';
        else
          text = 'No puede limpiar el c.costos si la devolución tiene detalle.';
        this.toastHandlerService.showToast(
          'error',
          text
        );
        return;
      } else {
        this.stateClientId = ClientStateEnums.activo;
        this.formDevolution.controls["costCenterId"].patchValue(0);
        this.disabledDetail = true;
        return;
      }
    }
    const costCenterOld = this.devolutionContract.costCenterId;
    const costCenter = await firstValueFrom(this.devolutionService.getCostCenterByIdAsync(costCenterId));
    if (costCenter !== null && costCenter.costCenterId !== 0) {
      this.filterCostCenterByClientId(costCenter.clientId);
      if (costCenterOld !== costCenter.costCenterId && this.quantityDetails !== 0) {
        setTimeout(() => this.formDevolution.controls["costCenterId"].patchValue(this.devolutionContract.costCenterId), 200);
        let text;
        if (this.devolutionContract.isPredevolution)
          text = 'No puede cambiar el c.costos si la predevolución tiene detalle.';
        else
          text = 'No puede cambiar el c.costos si la devolución tiene detalle.';
        this.toastHandlerService.showToast(
          'warning',
          text
        );
      } else {
        this.stateCostCenterId = costCenter.constructionSiteStateId;
        this.codeNameClient = costCenter.codeNameClient;
        this.stateClientId = costCenter.clientStateId;
        setTimeout(() => this.formDevolution.controls["clientId"].patchValue(costCenter.clientId), 200);
        setTimeout(() => this.formDevolution.controls["costCenterId"].patchValue(costCenter.costCenterId), 200);
        if (!onInit) {
          try {
            const response = await firstValueFrom(this.devolutionService.validateStocksInCostCenter(costCenter.branchId, costCenter.costCenterId));
            if (!response) {
              this.toastHandlerService.showToast(
                'info',
                'Este C.Costos ya no tiene saldos.'
              );
            }
            this.disabledDetail = true;
          } catch (error) {
            console.error('Error to validate stocks in cost center:', error);
          }
        }
      }
    } else {
      if (this.quantityDetails != 0) {
        let text;
        if (this.devolutionContract.isPredevolution)
          text = 'No puede limpiar el c.costos si la predevolución tiene detalle.';
        else
          text = 'No puede limpiar el c.costos si la devolución tiene detalle.';
        this.toastHandlerService.showToast('warning', text);
      } else {
        this.stateCostCenterId = ConstructionSiteStateEnums.activa;
        this.codeNameClient = "";
        this.stateClientId = ClientStateEnums.activo;
        this.formDevolution.controls["costCenterId"].patchValue(0);
        this.disabledDetail = true;
      }
    }
  }

  async getDevolutionById() {
    try {
      this.devolutionContract = await firstValueFrom(this.devolutionService.getDevolutionById(this.devolutionId));
      this.devolutionId = this.devolutionContract.devolutionId;
      const branchChanged = this.branchId != this.devolutionContract.branchId;
      if (branchChanged) {
        this.branchId = this.devolutionContract.branchId;
        await this.getAllLists(true);
        this.cdr.detectChanges();
      }
      this.validateForm(this.devolutionContract);
    } catch (error) {
      console.error('Error to get devolution by ID.', error);
    }
  }

  getDevolutionDetailRepair(devolutionDetailModel: DevolutionDetailModel) {
    this.devolutionDetailRepair = devolutionDetailModel;
  }

  async getFilesToDevolution() {
    try {
      this.listFiles = await firstValueFrom(this.devolutionService.getFilesToDevolution(this.devolutionId));
      this.updateInputsForAttachFiles();
    } catch (error) {
      console.error('Error catch:', error);
    }
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    try {
      this.mainBranchByUser = await firstValueFrom(this.userAuthenticatedService.branchObservable.pipe(filter(branch => branch && branch.branchId !== 0)));
      this.companyId = this.mainBranchByUser.companyId;
      this.branchId = this.mainBranchByUser.branchId;
      await this.getBranch(this.mainBranchByUser.branchId, false);
      this.formDevolution.controls["branchId"].patchValue(this.mainBranchByUser.branchId);
    } catch (error) {
      console.error('Error to get first branch by user authenticated:', error);
    }
  }

  async getFreightByDevolution(costCenterId: number, VehicleId: number) {
    if (VehicleId != null && costCenterId != null) {
      /*recupera un flete segun typeVehicle dentro de los registro de obra sino buscara en fletes generales de las mismas
      condiciones de ubicacion de la obra
      */
      try {
        const freight = await firstValueFrom(this.freightService.getFreightByDocumentRental(costCenterId, VehicleId));
        if (freight) {
          this.formDevolution.controls["transportValue"].patchValue(freight.value);
          this.changeTransportValue();
        } else {
          this.toastHandlerService.showToast(
            'info',
            'No se ha definido valor de flete para el lugar de destino de la obra seleccionada.'
          );
          this.formDevolution.controls['transportValue'].patchValue(0);
        }
      } catch (error) {
        console.error('Error to get freight by document rental:', error);
      }
    }
  }

  async getGeneralParameter() {
    if (this.companyId != null && this.companyId != 0) {
      try {
        const response = await firstValueFrom(this.generalParameterService.getGeneralParametersByCompany(this.companyId));
        this.swFreight = response.some(x => x.name === "GeneraFletes");
        this.swIncludeStore = response.some(x => x.name === "ImprimirBodegaDocumento");
        this.swIndicators = response.some(x => x.name === "Indicadores");
      } catch (error) {
        console.error('Error to get general parameters by company:', error);
      }
    }
  }

  async getInvoicingCutoffCode(invoicingCutoffId: number | null) {
    if (invoicingCutoffId !== null && invoicingCutoffId !== 0) {
      this.invoicingCutoffCode = await firstValueFrom(this.invoiceService.getInvoicingCutoffCodeByIdAsync(invoicingCutoffId));
    } else {
      this.invoicingCutoffCode = "";
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'warning',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    await this.getFirstBranchByUserAuthenticatedAsync();
    await this.getGeneralParameter();
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
      this.getPermissionsForUserByWindow();
      await this.getAllLists(false);
      this.setInputsForModal();
      this.getPermissionPrint();
    } catch (error) {
      console.error('Error getting profile permissions.', error);
    }
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(this.userAuthenticatedService.userObservable.pipe(filter(user => user && user.userId !== 0)));
    this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.Devolution));
  }

  async getPermissionPrint() {
    try {
      this.permissionPrint = await firstValueFrom(this.devolutionService.getPermissionPrint());
    } catch (error) {
      console.error('Error to get permission print.', error);
    }
  }

  getQuantityDetails(quantityDetails: number) {
    this.quantityDetails = quantityDetails;
  }

  getTypeDocument(isPredevolution: number) {
    if (isPredevolution) {
      setTimeout(() => this.formControlStateService.setControlState(this.formDevolution, ['datePredevolution', 'advertiser'], true), 100);
      this.formDevolution.controls["datePredevolution"].patchValue(new Date());
    } else {
      setTimeout(() => this.formControlStateService.setControlState(this.formDevolution, ['datePredevolution', 'advertiser'], false), 100);
      this.formDevolution.controls["datePredevolution"].patchValue(null);
    }
  }

  async getTransporter(transporterId: number | null) {
    const transportOld = this.devolutionContract.transporterId;
    if (transporterId !== null && transporterId !== 0) {
      const transporter = this.listTransporter.find(x => x.value === transporterId);
      if (transporter) {
        //Si cambia el transportador y la devolución tiene detalle, pregunto si realmente desea cambiar el transportador:
        if (transportOld !== transporterId) {
          if (this.quantityDetails !== 0) {
            let text;
            if (this.devolutionContract.isPredevolution)
              text = 'La predevolución tiene artículos asociados. ¿Realmente desea modificar el transportador?';
            else
              text = 'La devolución tiene artículos asociados. ¿Realmente desea modificar el transportador?';

            const accepted = await this.confirmDialogService.confirm(text);

            if (accepted) {
              this.formDevolution.controls["transporterId"].patchValue(transporterId);
              this.disabledDetail = true;
            } else {
              this.formDevolution.controls["transporterId"].patchValue(transportOld);
            }
          } else {
            this.formDevolution.controls["transporterId"].patchValue(transporterId);
            this.disabledDetail = true;
          }
        } else {
          this.formDevolution.controls["transporterId"].patchValue(transporterId);
        }
      } else {
        //Si la devolución tiene detalle no puede quedar sin transportador:
        if (this.quantityDetails !== 0) {
          this.toastHandlerService.showToast('warning',
            `No puede limpiar el transportador si la ${this.devolutionContract.isPredevolution ? 'predevolución' : 'devolución'} tiene detalle.`
          );
          this.formDevolution.controls["transporterId"].patchValue(this.devolutionContract.transporterId);
        } else {
          this.formDevolution.controls["transporterId"].patchValue(0);
        }
      }
    } else {
      //Si la devolución tiene detalle no puede quedar sin transportador:
      if (this.quantityDetails != 0) {
        this.toastHandlerService.showToast('warning',
          `No puede limpiar el transportador si la ${this.devolutionContract.isPredevolution ? 'predevolución' : 'devolución'} tiene detalle.`
        );
        this.formDevolution.controls["transporterId"].patchValue(this.devolutionContract.transporterId);
      } else {
        this.formDevolution.controls["transporterId"].patchValue(0);
      }
    }
  }

  getUpdateListDetail() {
    this.updateListDetail = !this.updateListDetail;
  }

  async getVehicle(vehicleId: number | null) {
    const vehicleOld = this.devolutionContract.vehicleId;
    const costCenterId = this.formDevolution.get("costCenterId")?.value;
    if (vehicleId !== null && vehicleId !== 0) {
      const vehicle = this.listVehicle.find(x => x.value === vehicleId);
      if (vehicle) {
        if (vehicleOld !== vehicleId) {
          if (this.quantityDetails !== 0) {
            let text;
            if (this.devolutionContract.isPredevolution)
              text = 'La predevolución tiene artículos asociados. ¿Realmente desea modificar el vehículo?';
            else
              text = 'La devolución tiene artículos asociados. ¿Realmente desea modificar el vehículo?';
            const accepted = await this.confirmDialogService.confirm(text);

            if (accepted) {
              //consulta de valores de flete si esta habilitado SwFreights
              if (this.swFreight) this.getFreightByDevolution(costCenterId, vehicleId);
              this.formDevolution.controls["vehicleId"].patchValue(vehicleId);
              this.disabledDetail = true;
            } else {
              this.formDevolution.controls["vehicleId"].patchValue(vehicleOld);
            }
          } else {
            //consulta de valores de flete si esta habilitado SwFreights
            if (this.swFreight) this.getFreightByDevolution(costCenterId, vehicleId);
            this.formDevolution.controls["vehicleId"].patchValue(vehicleId);
          }
        } else {
          this.formDevolution.controls["vehicleId"].patchValue(vehicleId);
        }
      } else {
        //Si la devolución tiene detalle no puede quedar sin vehículo:
        if (this.quantityDetails != 0) {
          this.toastHandlerService.showToast('warning',
            `No puede limpiar el vehículo si la ${this.devolutionContract.isPredevolution ? 'predevolución' : 'devolución'} tiene detalle.`
          );
          this.formDevolution.controls["vehicleId"].patchValue(this.devolutionContract.vehicleId);
        } else {
          this.formDevolution.controls["vehicleId"].patchValue(0);
        }
      }
    } else {
      //Si la devolución tiene detalle no puede quedar sin vehículo:
      if (this.quantityDetails != 0) {
        this.toastHandlerService.showToast('warning',
          `No puede limpiar el vehículo si la ${this.devolutionContract.isPredevolution ? 'predevolución' : 'devolución'} tiene detalle.`
        );
        this.formDevolution.controls["vehicleId"].patchValue(this.devolutionContract.vehicleId);
      } else {
        this.formDevolution.controls["vehicleId"].patchValue(0);
      }
    }
  }

  goToHome(event: Event) {
    event.preventDefault();
    this.router.navigate(['/main']);
  }

  goToBack(event: Event) {
    event.preventDefault();
    this.router.navigate(['/devolution']);
  }

  async handleInitialState() {
    if (this.devolutionId !== null && this.devolutionId !== 0) {
      await this.getDevolutionById();
    } else {
      this.createNewDevolution(this.mainBranchByUser.branchId);
    }
  }

  async openAttachFile() {
    if (this.devolutionContract.devolutionId != 0 && this.devolutionContract.devolutionId != null) {
      await this.getFilesToDevolution();
      this.attachFileDevolutionComponent && this.attachFileDevolutionComponent.show();
    } else {
      this.toastHandlerService.showToast('warning', 'Debe crear una devolución.', 'Atención');
    }
  }

  async onSave() {
    if (!this.formDevolution.valid) {
      this.showValidationMessages();
      return;
    }
    try {
      this.branchId = this.formDevolution.get("branchId")?.value;
      const response = await firstValueFrom(this.devolutionService.hasExistingDevolution(this.branchId));
      if (!response) {
        this.initialConsecutiveModalComponent?.show();
        return;
      }
      await this.send();
    } catch (error) {
      console.error('Error al buscar la ultima devolución.', error);
    }
  }

  // openDevolutionAttachmentsModal() {
  //   if (this.devolutionContract.devolutionId != 0 && this.devolutionContract.devolutionId != null) {
  //     this.devolutionModalComponent && this.devolutionModalComponent.show();
  //   } else {
  //     this.toastHandlerService.showToast('warning', 'Debe crear una devolución.', 'Atención');
  //   }
  // }

  openRepairModal() {
    if (this.devolutionContract.devolutionId != 0 && this.devolutionContract.devolutionId != null) {
      this.headerRepair = 'Reparaciones';
      this.inputsForRepairModals$.next({
        devolutionDetailId: this.devolutionDetailRepair.devolutionDetailId,
        disabledDetail: this.disabledDetail
      });
      setTimeout(() => { this.repairModalComponent && this.repairModalComponent.show() }, 0);
    } else {
      this.toastHandlerService.showToast('warning', 'Debe crear un cliente.');
    }
  }

  async printDocument() {
    if (this.devolutionContract.devolutionId != 0 && this.devolutionContract.devolutionId != null) {
      if (this.permissionPrint) {
        if (this.quantityDetails !== 0) {
          if (this.devolutionContract.isPredevolution) {
            this.selectOptionPrintModalComponent && this.selectOptionPrintModalComponent.show();
          } else {
            this.printOnlyQuantity = false;
            this.toastHandlerService.clearAllToasts();
            await this.printPage();
          }
        } else {
          this.toastHandlerService.showToast(
            'warning',
            'No puede imprimir un documento sin detalle.'
          );
          return;
        }
      } else {
        if (this.devolutionContract.isPredevolution) {
          this.toastHandlerService.showToast(
            'error',
            'El usuario no tiene permisos para imprimir predevoluciones. Comuníquese con el administrador del sistema.'
          );
          return;
        } else {
          this.toastHandlerService.showToast(
            'error',
            'El usuario no tiene permisos para imprimir devoluciones. Comuníquese con el administrador del sistema.'
          );
          return;
        }
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un registro.'
      );
    }
  }

  async printPage() {
    if (this.devolutionContract.devolutionId != 0 && this.devolutionContract.devolutionId != null) {
      if (this.permissionPrint) {
        this.devolutionPrintModel = await firstValueFrom(
          this.devolutionService.getDevolutionByKeysByPrintAsync(this.devolutionContract.branchId, 0, this.devolutionContract.devolutionId,
            this.devolutionContract.isPredevolution, this.swIncludeStore, this.printOnlyQuantity
          )
        );
        this.reloadPrint = !this.reloadPrint;
        await this.updateStatusToPrinted();
      } else {
        this.toastHandlerService.showToast(
          'error',
          'El usuario no tiene permisos para imprimir devoluciones. Comuníquese con el administrador del sistema.'
        );
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear una devolución.'
      );
    }
  }

  async printPredevolution(params: any) {
    this.printOnlyStore = params.printStore;
    this.printOnlyQuantity = params.printQuantity;
    let printOption: boolean = false;
    if (params.printStore) {
      printOption = false
    } else if (!params.printStore && params.printQuantity) {
      printOption = true;
    }
    this.devolutionPrintModel = await firstValueFrom(
      this.devolutionService.getDevolutionByKeysByPrintAsync(this.devolutionContract.branchId, 0, this.devolutionContract.devolutionId,
        this.devolutionContract.isPredevolution, this.swIncludeStore, printOption
      )
    );
    this.reloadPrint = !this.reloadPrint;
    this.updateStatusToPrinted();
  }

  async reloadListDetail(params: any) {
    if (params.reload) {
      this.getUpdateListDetail();
    }
  }

  reloadWindow(event: Event) {
    event.preventDefault();
    if (this.devolutionId != 0 && this.devolutionId != null) {
      this.router.navigate(['/devolution/register/', this.devolutionId]);
    } else {
      this.router.navigate(['/devolution/register']);
    }
  }

  async send() {
    Object.keys(this.formDevolution.controls).forEach(key => {
      const control = this.formDevolution.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });
    if (this.formDevolution.valid) {
      //Hago enable el campo de tipo de entrada para que me permita guardarlo:
      this.formDevolution.controls['consecutive'].enable();
      this.formDevolution.enable();

      const modelDevolution = this.formDevolution.value as DevolutionModel;

      //Hago null, los campos que permiten ser nulos:
      if (modelDevolution.alterNumber === 0) modelDevolution.alterNumber = null;
      if (modelDevolution.advertiser?.trim() === "") modelDevolution.advertiser = null;
      if (modelDevolution.wildcard?.trim() === "") modelDevolution.wildcard = null;
      if (modelDevolution.wildcard2?.trim() === "") modelDevolution.wildcard2 = null;
      if (modelDevolution.printObservation?.trim() === "") modelDevolution.printObservation = null;
      if (modelDevolution.observation?.trim() === "") modelDevolution.observation = null;

      //Verifico que si es predevolución tenga una anunciante:
      if (modelDevolution.isPredevolution) {
        if (modelDevolution.advertiser === null) {
          this.toastHandlerService.showToast(
            'warning',
            'El campo Anunciante es requerido.'
          );
          return;
        }

        const datePredevolution = moment(this.formDevolution.get("datePredevolution")?.value).startOf('day');
        const dateDevolution = moment(this.formDevolution.get("dateDevolution")?.value).startOf('day');
        if (dateDevolution.isBefore(datePredevolution)) {
          this.toastHandlerService.showToast(
            'warning',
            `La Fecha Devolución: ${dateDevolution.format('YYYY-MM-DD')}, no puede ser menor a la Fec.Predevolución: ${datePredevolution.format('YYYY-MM-DD')}.`
          );
          return;
        }


      } else {
        modelDevolution.datePredevolution = null;
      }

      if (this.devolutionId === 0) {
        try {
          this.devolutionContract = await firstValueFrom(this.devolutionService.createDevolution(modelDevolution));
          this.devolutionId = this.devolutionContract.devolutionId;
          this.validateForm(this.devolutionContract);
          this.location.replaceState(`/devolution/register/${this.devolutionId}`);
          this.toastHandlerService.showToast(
            'success',
            `La ${modelDevolution.isPredevolution ? 'pre' : ''}devolución fue creada exitosamente.`
          );
        } catch (error) {
          this.updateFormState();
          console.error('Error to create devolution.', error);
          setTimeout(() => this.formDevolution.controls["consecutive"].patchValue(0));
        }
      } else {
        this.devolutionContract.alterNumber = modelDevolution.alterNumber;
        this.devolutionContract.costCenterId = modelDevolution.costCenterId;
        this.devolutionContract.datePredevolution = modelDevolution.datePredevolution;
        this.devolutionContract.advertiser = modelDevolution.advertiser;
        this.devolutionContract.dateDevolution = modelDevolution.dateDevolution;
        this.devolutionContract.dateInvoice = modelDevolution.dateInvoice;
        this.devolutionContract.swDontChargeInvoiceDay = modelDevolution.swDontChargeInvoiceDay;
        this.devolutionContract.transportValue = modelDevolution.transportValue;
        this.devolutionContract.transportValuePay = modelDevolution.transportValuePay;
        this.devolutionContract.transporterId = modelDevolution.transporterId;
        this.devolutionContract.vehicleId = modelDevolution.vehicleId;
        this.devolutionContract.wildcard = modelDevolution.wildcard;
        this.devolutionContract.wildcard2 = modelDevolution.wildcard2;
        this.devolutionContract.printObservation = modelDevolution.printObservation;
        this.devolutionContract.observation = modelDevolution.observation;
        this.devolutionContract.datePickup = modelDevolution.datePickup;
        this.devolutionContract.conceptTypeRequirementId = modelDevolution.conceptTypeRequirementId;
        this.devolutionContract.conceptDelayReasonId = modelDevolution.conceptDelayReasonId;

        try {
          this.devolutionContract = await firstValueFrom(this.devolutionService.updateDevolution(this.devolutionContract));
          this.validateForm(this.devolutionContract);
          this.toastHandlerService.showToast(
            'success',
            `La ${modelDevolution.isPredevolution ? 'pre' : ''}devolución fue modificada exitosamente.`
          );
        } catch (error) {
          this.updateFormState();
          console.error('Error to update the devolution.', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  setInputsForModal() {
    this.inputsForModals$.next({
      devolutionId: this.devolutionContract.devolutionId,
      devolutionStateId: this.devolutionContract.devolutionStateId,
      permissionUpdatable: this.permissionUpdatable
    });
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      branchId: {
        required: 'El campo Sucursal es obligatorio.',
        min: 'Debes seleccionar una Sucursal válida.'
      },
      alterNumber: {
        max: 'El valor máximo del número alterno es 9999999'
      },
      dateDevolution: {
        required: 'La Fecha de Devolución es obligatoria.'
      },
      dateInvoice: {
        required: 'La Fecha de Factura es obligatoria.'
      },
      costCenterId: {
        required: 'El campo Centro de Costos es obligatorio.',
        min: 'Debes seleccionar un Centro de Costos válido.',
        pattern: 'El campo Centro de Costos debe ser un valor válido.'
      },
      clientId: {
        required: 'El campo Cliente es obligatorio.',
        min: 'Debes seleccionar un Cliente válido.',
        pattern: 'El campo Cliente debe ser un valor válido.'
      },
      wildcard: {
        maxlength: 'El campo comodín 1 no puede tener más de 20 caracteres.'
      },
      wildcard2: {
        maxlength: 'El campo comodín 2 no puede tener más de 20 caracteres.'
      },
      transporterId: {
        required: 'El campo Transportador es obligatorio.',
        min: 'Debes seleccionar un Transportador válido.'
      },
      vehicleId: {
        required: 'El campo Vehículo es obligatorio.',
        min: 'Debes seleccionar un Vehículo válido.'
      },
      transportValue: {
        required: 'El Valor del Transporte es obligatorio.',
        min: 'El Valor del Transporte no puede ser negativo.'
      },
      transportValuePay: {
        required: 'El Valor del Transporte a Pagar es obligatorio.',
        min: 'El Valor del Transporte a Pagar no puede ser negativo.'
      },
      printObservation: {
        maxlength: 'La Observación para impresión no puede tener más de 250 caracteres.'
      },
      observation: {
        maxlength: 'La Observación no puede tener más de 250 caracteres.'
      }
    };

    Object.keys(controlMessages).forEach((control) => {
      const formControl = this.formDevolution.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach((errorKey) => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  updateFormState() {
    switch (this.devolutionContract.devolutionStateId) {
      case DevolutionStateEnums.abierto: {
        this.devolutionStateString = "Abierto";
        this.iconStateDevolution = 'pi pi-lock-open';
        this.titleStateDevolution = "Cerrar";
        break;
      }
      case DevolutionStateEnums.anulado: {
        this.devolutionStateString = "Anulado";
        this.iconStateDevolution = 'pi pi-lock';
        this.titleStateDevolution = "Abrir";
        break;
      }
      case DevolutionStateEnums.cerrado: {
        this.devolutionStateString = "Cerrado";
        this.iconStateDevolution = 'pi pi-lock';
        this.titleStateDevolution = "Abrir";
        break;
      }
      case DevolutionStateEnums.impreso: {
        this.devolutionStateString = "Impreso";
        this.iconStateDevolution = 'pi pi-lock';
        this.titleStateDevolution = "Abrir";
        break;
      }
    }

    if (this.devolutionContract.devolutionStateId === DevolutionStateEnums.abierto && !this.devolutionContract.swBlock) {
      this.disabledDetail = false;
      this.disabledForm = false;
      setTimeout(() => this.formDevolution.enable(), 100);
      if (this.devolutionContract.isPredevolution) {
        setTimeout(() => this.formControlStateService.setControlState(this.formDevolution, ['branchId', 'alterNumber', 'datePredevolution', 'advertiser'], true), 100);
      } else {
        setTimeout(() => this.formDevolution.controls["alterNumber"].enable(), 100);
        setTimeout(() => this.formControlStateService.setControlState(this.formDevolution, ['datePredevolution', 'advertiser'], false), 100);
      }
    } else {
      this.disabledDetail = true;
      this.disabledForm = true;
      setTimeout(() => this.formDevolution.disable(), 100);
    }

    //Habilita el campo de fecha de facturacion cuando el periodo este cerrado y no este en corte
    if (this.devolutionContract.rentalPeriod.active == false && this.devolutionContract.invoicingCutoff == null && !this.devolutionContract.swBlock &&
      this.devolutionContract.devolutionStateId != DevolutionStateEnums.anulado) {
      setTimeout(() => this.formDevolution.controls["dateInvoice"].enable(), 100);
      this.disabledBtnSave = true;
    }

    if (!this.permissionUpdatable) {
      this.disabledDetail = true;
      this.disabledForm = true;
      setTimeout(() => this.formDevolution.disable(), 100);
    }

    if (this.devolutionContract.devolutionId === 0 || this.devolutionContract.devolutionId === null) {
      setTimeout(() => this.formControlStateService.setControlState(this.formDevolution, ['consecutive', 'swBlock'], false), 100);
      this.disabledDetail = true;
    } else {
      setTimeout(() => this.formControlStateService.setControlState(this.formDevolution, ['branchId', 'consecutive', 'swBlock'], true), 100);
      setTimeout(() => this.formControlStateService.setControlState(this.formDevolution, ['isPredevolution'], false), 100);
    }

    if (this.devolutionContract.isTransfer === true) {
      this.formDevolution.disable();
      setTimeout(() => this.disabledDetail = true, 100);
      setTimeout(() => this.formControlStateService.setControlState(this.formDevolution, ['branchId', 'consecutive', 'dateInvoice'], true), 100);
    }
  }

  async updateStatusToPrinted() {
    try {
      this.devolutionContract = await firstValueFrom(this.devolutionService.printDevolution(this.devolutionContract.devolutionId));
      this.validateForm(this.devolutionContract);
    } catch (error) {
      console.error('Error to update the devolution status to printed:', error);
    }
  }

  updateInputsForAttachFiles() {
    this.inputsForAttachFiles$.next({
      listFiles: this.listFiles,
      labelConsecutive: this.devolutionContract.consecutive,
      disabled: this.devolutionContract.devolutionStateId != DevolutionStateEnums.abierto
    });
  }

  async uploadFile(formData: any) {
    try {
      await firstValueFrom(this.devolutionService.attachFilesToDevolution(this.devolutionId, formData));
      await this.getFilesToDevolution();
      this.toastHandlerService.showToast('success', 'Se adjunto el archivo exitosamente', '');
    } catch (error) {
      console.error('Error catch:', error);
    }
  }

  validateForm(devolution: DevolutionModel) {
    this.formDevolution = this.formBuilder.group({
      branchId: [devolution.branchId, [Validators.required, Validators.min(1)]],
      consecutive: [devolution.consecutive],
      alterNumber: [devolution.alterNumber, [Validators.max(9999999)]],
      isPredevolution: [devolution.isPredevolution],
      swBlock: [devolution.swBlock],
      datePredevolution: [devolution.datePredevolution ? this.dateConverterService.convertUtcToLocalDate(devolution.datePredevolution) : null],
      advertiser: [devolution.advertiser],
      dateDevolution: [devolution.dateDevolution ? this.dateConverterService.convertUtcToLocalDate(devolution.dateDevolution) : null, [Validators.required]],
      dateInvoice: [devolution.dateInvoice ? this.dateConverterService.convertUtcToLocalDate(devolution.dateInvoice) : null, [Validators.required]],
      costCenterId: [devolution.costCenterId, [Validators.required, Validators.min(1), Validators.pattern(/^\d+$/)]],
      clientId: [0, [Validators.required, Validators.pattern(/^\d+$/)]],
      wildcard: [devolution.wildcard, [Validators.maxLength(20)]],
      wildcard2: [devolution.wildcard2, [Validators.maxLength(20)]],
      transporterId: [devolution.transporterId, [Validators.required, Validators.min(1)]],
      vehicleId: [devolution.vehicleId, [Validators.required, Validators.min(1)]],
      transportValue: [devolution.transportValue, [Validators.required, Validators.min(0)]],
      swDontChargeInvoiceDay: [devolution.swDontChargeInvoiceDay],
      transportValuePay: [devolution.transportValuePay, [Validators.required, Validators.min(0)]],
      printObservation: [devolution.printObservation, [Validators.maxLength(250)]],
      observation: [devolution.observation, [Validators.maxLength(250)]],
      datePickup: [devolution.datePickup ? this.dateConverterService.convertUtcToLocalDateFull(devolution.datePickup) : null],
      conceptTypeRequirementId: [devolution.conceptTypeRequirementId],
      conceptDelayReasonId: [devolution.conceptDelayReasonId]
    });
    if (devolution.devolutionId !== 0 && devolution.devolutionId !== null) {
      this.devolutionId = this.devolutionContract.devolutionId;
      this.formDevolution.enable();
      this.getBranch(this.devolutionContract.branchId, false);
      this.getCostCenter(this.devolutionContract.costCenterId, true);
      this.getTransporter(this.devolutionContract.transporterId);
      this.getVehicle(this.devolutionContract.vehicleId);
      this.getInvoicingCutoffCode(this.devolutionContract.invoicingCutoffId);
      this.statePeriod = this.devolutionContract.rentalPeriod.active ? 'Abierto' : 'Cerrado';
      this.datePeriod = this.datePipe.transform(this.devolutionContract.rentalPeriod.initialDate, 'yyyy-MM', 'en-US');
      this.dataPeriod = `${this.datePeriod} - ${this.statePeriod}`;
    }
    this.setInputsForModal();
    this.updateFormState();
  }

}
